import { IPersonCerts } from "../models/IPerson";
import { IPersonCert } from "../models/IPersonCert";
import { IHprSettings } from "../models/IHprSettings";

import { ECertStatus } from "../models/ICert";


export const getPersonCertStatus = (personCert: IPersonCert, timeLimited: boolean = false) => {
    if (timeLimited && personCert.valid && personCert.expires) {
        return ECertStatus.Expires;
    }

    return personCert.valid ? ECertStatus.Valid : ECertStatus.NotValid;
}


export const getCertStatus = (personCerts: IPersonCerts, certs: IHprSettings["certs"], requiredCerts: Array<string>) => {
    return requiredCerts.reduce<ECertStatus>((acc, key) => {
        const personCert = personCerts[key];
        const cert = certs[key]

        const status = personCert ? getPersonCertStatus(personCert, cert.isTimeLimited) : ECertStatus.NotValid

        if (acc !== ECertStatus.NotValid) {
            acc = status;
        };

        return acc
    }, ECertStatus.Valid)
};